import { type FC, type HTMLAttributes, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

import { AppRoute } from '@/common/app/routes';
import { useMatchPath } from '@/common/hooks/match-path';
import { Balance } from '@/components/Balance/Balance';
import { ModalContext } from '@/components/Modals/Modal/config';
import BurgerSettings from '@/components/ui/BurgerSettings/BurgerSettings';
import { Button } from '@/components/ui/Button/Button';
import { Plus } from '@/components/ui/Plus/Plus';
import { UserLevel } from '@/components/UserLevel/UserLevel';

import css from './styles.module.scss';

const isNativeApp = Capacitor.isNativePlatform();

const UserBasicInfo: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { openModal, closeModal, modalContent } = useContext(ModalContext);
  const navigate = useNavigate();

  const isUserBasicInfoVisible = useMatchPath([
    AppRoute.MAIN,
    AppRoute.STOCK,
    AppRoute.EARN,
    AppRoute.RESOURCES,
    AppRoute.FACTORY,
    AppRoute.WORKSHOP,
    AppRoute.SHOP,
    AppRoute.DICE_GAME,
    AppRoute.GAME_CENTER,
    AppRoute.BINGO,
    AppRoute.BINGO_LEADERBOARD,
    AppRoute.SCRATCH,
  ]);
  const isUserBasicInfoInvisibleByModal = ['buyMarketBox'].includes(
    modalContent.renderKind,
  );

  const openCoinDeposit = (): void => {
    openModal({
      renderKind: 'coinDeposit',
      props: { source: 'header_balance' },
    });
  };

  return (
    isUserBasicInfoVisible &&
    !isUserBasicInfoInvisibleByModal && (
      <div {...props} className="header flex items-center justify-between px-4">
        <div className="flex items-center gap-1">
          <BurgerSettings />
          <UserLevel />
        </div>
        <div className="flex items-center gap-1">
          {/* The native app has no USDT balance */}
          {!isNativeApp && (
            <Balance
              className="gap-[0.125rem]"
              kind="usdt"
              onClick={() => {
                closeModal();
                navigate(AppRoute.SETTINGS);
              }}
            />
          )}
          <Balance className="gap-[0.125rem]" kind="cash" />
          <Balance className="gap-[0.125rem]" kind="tgem">
            <Button variant="transparent" onClick={openCoinDeposit}>
              <Plus className={css.plus} variant="green-header" />
            </Button>
          </Balance>
          {/* <NotificationIcon /> */}
        </div>
      </div>
    )
  );
};

export { UserBasicInfo };
